interface PageTitleAndHeroTextProps {
  title: string;
  text: string;
}
export const PageTitleAndHeroText = ({
  title,
  text,
}: PageTitleAndHeroTextProps) => {
  return (
    <>
      <div className="text-14-16 text-gray-600 sm:text-18-28">{title}</div>
      <div className="mt-8 max-w-[640px] font-display text-32-40 text-gray-900 sm:mt-12 sm:text-[56px] sm:leading-[56px]">
        {text}
      </div>
    </>
  );
};
